import { Trash } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { IntegrationSettings } from "common/types";

import { INTEGRATIONS_MAP } from "../constants";

export default function RemoveIntegrationButton({
  integrationKey,
  onRemove,
}: {
  integrationKey: keyof IntegrationSettings;
  onRemove: () => void;
}) {
  const isDesktop = useTwBreakpoint("lg");
  const { title } = INTEGRATIONS_MAP[integrationKey];

  return (
    <Button
      variant={isDesktop ? "link-danger" : "ghost-danger"}
      size={isDesktop ? "sm" : "md"}
      className="self-end"
      leftIcon={<Trash />}
      onClick={onRemove}
    >
      Remove {title}
    </Button>
  );
}
